import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
emailjs.init(publicKey);

export const sendEmail = async ({ to, subject, message, fromName, replyTo }) => {
  try {
    const templateParams = {
      to_email: to,
      from_name: fromName || process.env.REACT_APP_SENDER_NAME || 'AICIS Conference Team',
      from_email: process.env.REACT_APP_SENDER_EMAIL || 'conference@aicis.com',
      subject: subject,
      message: message,
      reply_to: replyTo || process.env.REACT_APP_SENDER_EMAIL || 'conference@aicis.com',
    };

    console.log('📧 Sending email with params:', templateParams);

    const response = await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams
    );

    console.log('✅ Email sent successfully:', response);
    return response;
  } catch (error) {
    console.error('❌ Failed to send email:', error);
    throw error;
  }
};